<header class="header--page" *ngIf="includeHeader">
    <ul class="header__nav">
        <li class="header__vehicle" [attr.aria-expanded]="true">
            <h1 class="header__circle" *ngIf="vehicle">
                <i class="material-icons">directions_car</i>
                <span class="header__block">
                    {{vehicle.modelYear}} {{vehicle.makeDisplayValue }} {{vehicle.modelDisplayValue}}
                    <span class="header__block__sub">VIN: {{vehicle.vin}} <ng-container *ngIf="filteredCustomerList()!=null && filteredCustomerList().length > 0 && filteredCustomerList().length < 4"><ng-container *ngFor="let c of filteredCustomerList();">&nbsp; | &nbsp; {{c?.customer?.customerName}}</ng-container></ng-container><ng-container *ngIf="filteredCustomerList()!=null && filteredCustomerList().length > 3">&nbsp; | &nbsp; Multiple Owners</ng-container></span>
                </span>
            </h1>
        </li>
    </ul>
</header>
<p-toast></p-toast>
<div class="mvd_container mvd_container--pdf">
    <form>
        <header class="header--well">
            <ul>
                <li class="header__title">
                    <h2>Vehicle Information</h2>
                </li>
                <li>
                    <div class="btn-toolbar" role="toolbar" *ngIf="!!vehicleOwnershipModel">
                        <button class="btn--default" type="button" *ngIf="canUploadToMobileHomeRecord && vehicle.vehicleTypeID == vehicleType.MobileHome.id" (click)="addVehicleDocuments()">Add Documents</button>
                        <button class="btn--default" type="button" *ngIf="vehicle.vehicleTypeID === vehicleType.MobileHome.id" (click)="viewVehicleDocuments()">Vehicle Documents</button>
                        <button [ngClass]="(isOIGFraudNoteExisted)?'btn--accent':'btn--default'" type="button" (click)="viewVehicleNotes()">Vehicle Notes</button>
                        <button class="btn--default" type="button" (click)="viewVehicleHistory()">Vehicle History</button>
                        <button class="btn--default" type="button" (click)="beginService()" *ngIf="!isUserAssociatedToVehicle">Begin Service</button>
                    </div>
                </li>
            </ul>
        </header>
        <div class="well" *ngIf="dataLoaded">
            <div class="list--ancors">
                <ul class="list--menu">
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Vehicle')">Vehicle</a>
                    </li>
                    <li *ngIf="registration">
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Registration')">Registration</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Withdrawals')">Withdrawals</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Owners')">Owners</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Title')">Title</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Brands')">Brands</a>
                    </li>
                    <li *ngIf="vehicleEmissionCheckStatusRegistration && vehicleEmissionCheckStatusRegistration.vehicleEmissionTest">
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Emissions')">Emissions</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Permits')">Permits</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Decal')">Decal</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('SoldNotice')">Sold Notice</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Insurance')">Insurance</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('DeInsurance')">De-Insurance</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('WatchYourCar')">Watch Your Car</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('Fleets')">Fleets</a>
                    </li>
                    <li>
                        <a class="list__link" href="javascript:void(0);" (click)="goTo('CmlPermits')">CML Permits</a>
                    </li>
                </ul>
            </div>
            <h2 id="Vehicle"> Vehicle Information <button class="icon--edit btn--default" ifACSTransaction="LECURestrictions" (click)="launchUpdateDetailsModal()">LECU</button></h2>
            <table class="mvd_table--primeng">
                <thead>
                    <tr>
                        <th>VIN</th>
                        <th>VIN Type</th>
                        <th>Vehicle Type</th>
                        <th>Year</th>
                        <th colspan="2">Make</th>
                        <th colspan="2">Model</th>
                        <th>IRP</th>
                    </tr>
                </thead>
                <tbody *ngIf="vehicle">
                    <tr>
                        <td>{{vehicle.vin}}</td>
                        <td>{{vehicle.vinTypeID | displayValue:vinTypes}}</td>
                        <td>{{vehicle.vehicleTypeID | displayValue:vehicleTypes}}</td>
                        <td>{{vehicle.modelYear}}</td>
                        <td colspan="2">{{vehicle.makeDisplayValue }}</td>
                        <td colspan="2">{{vehicle.modelDisplayValue}}</td>
                        <td *ngIf="userHasAccessControlType('UpdIRPIndicator')"><input type="checkbox" [(ngModel)]="vehicle.isApportioned" [ngModelOptions]="{standalone: true}" (change)="isApportionedChanged($event)" /></td>
                        <td *ngIf="!userHasAccessControlType('UpdIRPIndicator')">{{vehicle.isApportioned | yesNo}}</td>
                    </tr>
                    <tr>
                        <th>Body Style</th>
                        <th>Fuel Type</th>
                        <th>Factory List Price</th>
                        <th>First Registered</th>
                        <th>Tonnage</th>
                        <th>Unladen Weight</th>
                        <th>Length</th>
                        <th>Width</th>
                        <th>Axles</th>
                    </tr>
                    <tr *ngIf="vehicle">
                        <td>{{vehicle.bodyStyleTypeID | displayValue:bodyStyleTypes}}</td>
                        <td *ngIf="vehicle.alternativeFuelTierTypeId">{{vehicle.fuelTypeID | displayValue:fuelTypes}} - {{ vehicle.alternativeFuelTierTypeId | displayValue:alternativeFuelTierTypes }}</td>
                        <td *ngIf="!vehicle.alternativeFuelTierTypeId">{{vehicle.fuelTypeID | displayValue:fuelTypes}}</td>
                        <td>{{vehicle.factoryListPrice | currency:'USD':'symbol-narrow'}}</td>
                        <td><ng-container *ngIf="vehicle.monthFirstRegistered">{{vehicle.monthFirstRegistered | number:'2.0-0'}}/{{vehicle.yearFirstRegistered}}</ng-container></td>
                        <td>{{vehicle.tonnageRatingTypeID | displayValue:tonnageRatingTypes}}</td>
                        <td>{{vehicle.unladenWeight}}</td>
                        <td>{{vehicle.trailerLength}} <span *ngIf="vehicle.trailerLength">ft</span></td>
                        <td>{{vehicle.trailerWidth}} <span *ngIf="vehicle.trailerWidth">ft</span></td>
                        <td>{{vehicle.axles}}</td>
                    </tr>
                    <tr *ngIf="vehicle.isApportioned">
                        <th>Combined Axles</th>
                        <th>Seats</th>
                        <th colspan="7"></th>
                    </tr>
                    <tr *ngIf="vehicle?.isApportioned">
                        <td>{{vehicle.combinedAxles}}</td>
                        <td>{{vehicle.seats}}</td>
                        <td colspan="7"></td>
                    </tr>
                </tbody>
            </table>

            <mobile-home-linked-sections [vehicleId]="vehicleId" [vehicleOwnership]="vehicleOwnershipModel" *ngIf="isMobileHome"></mobile-home-linked-sections>

            <router-outlet name="registration"></router-outlet>
            <router-outlet name="withdrawal"></router-outlet>
            <h2 id="Owners">Ownership</h2>
            <table class="mvd_table--primeng">
                <thead>
                    <tr>
                        <th>Customer Name</th>
                        <th>Type</th>
                        <th>Title</th>
                        <th>Reg</th>
                        <th>Customer Number</th>
                        <th>Role Type</th>
                        <th>Address</th>
                        <th>Lien Effective Date</th>
                        <th>Address Type</th>
                        <th>Legal Status</th>
                    </tr>
                </thead>
                <tbody *ngIf="vehicleOwnershipModel">
                    <tr *ngFor="let c of filteredCustomerList()">
                        <td>
                            <a href="javascript:void(0)" (click)="showCustomerSummaryModal(c.customer.customerNumberID)">
                                <label>{{c?.customer?.customerName}}</label>
                            </a>
                        </td>
                        <td>{{c?.customer?.customerTypeId | displayValue:customerTypes}}</td>
                        <td><ng-container *ngIf="c?.titleMailTo"><i class="material-icons">star</i></ng-container></td>
                        <td><ng-container *ngIf="c?.registrationMailTo"><i class="material-icons">star</i></ng-container></td>
                        <td>{{c?.customerNumberID}}</td>
                        <td>{{c?.ownershipRoleTypeID | displayValue:ownershipRoleTypes}}</td>
                        <td><ng-container *ngIf="hasAddress(c?.customer)">{{getCustomerAddress(c?.customer).addressLine1}}<ng-container *ngIf="getCustomerAddress(c?.customer).addressLine2">, {{getCustomerAddress(c?.customer).addressLine2}}</ng-container>, {{getCustomerAddress(c?.customer).city}}, {{getCustomerAddress(c?.customer).jurisdictionId | displayValue:jurisdictions}} {{getCustomerAddress(c?.customer).postalZipCode}}, {{getCustomerAddress(c?.customer).countyId | displayValue:counties}}</ng-container></td>
                        <td>{{getLienEffectiveDate(c?.id, c?.ownershipRoleTypeID) | shortDate}}</td>
                        <td><ng-container *ngIf="hasAddress(c?.customer)">{{getCustomerAddress(c?.customer).addressTypeId | displayValue:addressTypes}}</ng-container></td>
                        <td>{{c?.legalStatusTypeID | displayValue:legalStatusTypes}}</td>
                    </tr>
                </tbody>
                <tbody *ngIf="!vehicleOwnershipModel">
                    <tr>
                        <td colspan="10">No Information Available</td>
                    </tr>
                </tbody>
            </table>
            <h2 id="Title">Title <button class="icon--history btn--default" type="button" (click)="viewTitleHistory()">View History</button></h2>
            <table class="mvd_table--primeng" *ngIf="vehicle">
                <thead>
                    <tr>
                        <th>Title Number</th>
                        <th>State</th>
                        <th>Title Issue Date</th>
                        <th>Print Date</th>
                        <th>Title Source</th>
                        <th>Title Status</th>
                    </tr>
                </thead>
                <tbody *ngIf="vehicleOwnershipModel && vehicleOwnershipModel.title">
                    <tr>
                        <td>{{vehicleOwnershipModel.title.titleNumber}}</td>
                        <td>AZ</td>
                        <td>{{getFormattedTitleIssuedDate()}}</td>
                        <td>{{vehicleOwnershipModel.title.titlePrintedDate | shortDate}}</td>
                        <td>{{vehicleOwnershipModel.title.titleSourceTypeId | displayValue:titleSourceTypes }}</td>
                        <td>{{vehicleOwnershipModel.title.titleStatusTypeID | displayValue:titleStatusTypes}}<ng-container *ngIf="isTitleCanceledWithAffixedReason"> / Affixed</ng-container></td>
                    </tr>
                    <tr>
                        <th>Odometer Reading</th>
                        <th>Miles/Kilometers</th>
                        <th>Reading Type</th>
                        <th colspan="3">Reading Date</th>
                    </tr>
                    <tr *ngIf="vehicleOwnershipModel.title.odometerReading">
                        <td>{{vehicleOwnershipModel.title.odometerReading.odometerReading | number}}</td>
                        <td>{{vehicleOwnershipModel.title.odometerReading.odometerReadingUnitTypeID | displayValue:odometerReadingUnitTypes}}</td>
                        <td>{{vehicleOwnershipModel.title.odometerReading.odometerReadingTypeID | displayValue:odometerReadingTypes}}</td>
                        <td colspan="3">{{vehicleOwnershipModel.title.odometerReading.odometerReadingDate | shortDate}}</td>
                    </tr>
                </tbody>
                <tbody *ngIf="!vehicleOwnershipModel || (vehicleOwnershipModel && !vehicleOwnershipModel?.title)">
                    <tr>
                        <td colspan="6">No Information Available</td>
                    </tr>
                </tbody>
            </table>
            <h2 id="Brands">Brands</h2>
            <table class="mvd_table--primeng">
                <thead>
                    <tr>
                        <th>Brand</th>
                        <th>State</th>
                        <th>Applied Date</th>
                        <th>Effective Date</th>
                        <th>End Date</th>
                    </tr>
                </thead>
                <tbody *ngIf="vehicle?.vehicleBrands?.length">
                    <tr *ngFor="let b of vehicle.vehicleBrands">
                        <td>{{ b.brandID | displayValue:brands}}</td>
                        <td>{{ b.jurisdictionID | displayValue:jurisdictions}}</td>
                        <td>{{ b.brandAppliedDate | shortDate }}</td>
                        <td>{{ b.effectiveDate | shortDate }}</td>
                        <td>{{ b.endDate | shortDate }}</td>
                    </tr>
                </tbody>
                <tbody *ngIf="!vehicle || !vehicle?.vehicleBrands?.length">
                    <tr>
                        <td colspan="5">No Information Available</td>
                    </tr>
                </tbody>
            </table>
            <h2 id="Emissions">
                Emissions
                <button class="icon--copy btn--default" type="button" (click)="copyVehicleEmissions()" *ngIf="vehicle && vehicleEmissionCheckStatusRegistration?.vehicleEmissionTest?.id > 0">Copy Emissions</button>
                <button class="icon--add btn--default" type="button" (click)="addVehicleEmissions()" *ngIf="vehicle && !isUserAssociatedToVehicle">Add Emissions</button>
            </h2>
            <table class="mvd_table--primeng">
                <thead>
                    <tr>
                        <th>Certificate Type</th>
                        <th>Test Area</th>
                        <th>Test Type</th>
                        <th>Initial Test Date</th>
                        <th>Initial Test Flag</th>
                        <th>Test Result</th>
                        <th>Passed Date</th>
                        <th>Expiration Date</th>

                    </tr>
                </thead>
                <tbody *ngIf="vehicleEmissionCheckStatusRegistration && vehicleEmissionCheckStatusRegistration?.vehicleEmissionTest?.id > 0">
                    <tr>
                        <td>{{vehicleEmissionCheckStatusRegistration.vehicleEmissionTest.emissionCertificateTypeID | displayValue:emissionCertificateTypes}}</td>
                        <td>{{vehicleEmissionCheckStatusRegistration.vehicleEmissionTest.emissionAreaTypeID | displayValue:emissionAreaTypes}}</td>
                        <td>{{vehicleEmissionCheckStatusRegistration.vehicleEmissionTest.emissionTestTypeID | displayValue:emissionTestTypes}}</td>
                        <td>{{vehicleEmissionCheckStatusRegistration.vehicleEmissionTest.initialTestDate | shortDate}}</td>
                        <td>{{vehicleEmissionCheckStatusRegistration.vehicleEmissionTest.initialTest | yesNo}}</td>
                        <td>{{vehicleEmissionCheckStatusRegistration.vehicleEmissionTest.emissionTestResultTypeID | displayValue:emissionTestResultTypes}}</td>
                        <td>{{vehicleEmissionCheckStatusRegistration.vehicleEmissionTest.testPassedDate | shortDate}}</td>
                        <td>{{vehicleEmissionCheckStatusRegistration.vehicleEmissionTest.testExpirationDate | shortDate}}</td>

                    </tr>
                </tbody>
                <tbody *ngIf="!vehicleEmissionCheckStatusRegistration || !vehicleEmissionCheckStatusRegistration?.vehicleEmissionTest || !(vehicleEmissionCheckStatusRegistration?.vehicleEmissionTest.id > 0)">
                    <tr>
                        <td colspan="8">No Information Available</td>
                    </tr>
                </tbody>
            </table>
            <h2 id="Permits">Permits</h2>
            <table class="mvd_table--primeng">
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Permit Number</th>
                        <th>Issue Date</th>
                        <th>Expiration Date</th>
                        <th>Status</th>
                        <th>Issued By</th>
                        <th>Issued To</th>
                        <th>TRP Credit Description</th>
                        <th>Cancellation Reason</th>
                        <th>Cancellation Date</th>
                        <th>Weight</th>
                        <th class="w--icon">Note</th>
                    </tr>
                </thead>
                <tbody *ngIf="vehicle && vehicle.vehiclePermits">
                    <tr *ngFor="let permit of vehicle.vehiclePermits;">
                        <td>{{permit.vehiclePermitTypeId | displayValue:vehiclePermitTypes}}</td>
                        <td *ngIf="permit.vehiclePermitTypeId != 105">{{permit.permitNumber}}</td>
                        <td *ngIf="permit.vehiclePermitTypeId == 105"><a href="javascript:void(0);" (click)="openTpaFeeSummaryModal(permit.permitNumber)">{{permit.permitNumber}}</a></td>
                        <td>{{permit.issueDate | shortDate}}</td>
                        <td>{{permit.expirationDate | shortDate}}</td>
                        <td>{{permit.vehiclePermitStatusTypeId | displayValue:permitStatusTypes}}</td>
                        <td><a href="javascript:void(0)" (click)="showCustomerSummaryModal(permit.vehiclePermitDealer.dealerCustomerNumberId)" *ngIf="permit.vehiclePermitDealer">{{permit.vehiclePermitDealer.customerIdentificationValue}}</a></td>
                        <td><a href="javascript:void(0)" (click)="showCustomerSummaryModal(permit.customer.customerNumberID)">{{permit.customer?.customerName}}</a></td>
                        <td>{{permit.description}}</td>
                        <td>{{permit.trpCancelReasonTypeId | displayValue:trpCancelReasonTypes}}</td>
                        <td>{{permit.cancellationDate | shortDate}}</td>
                        <td>{{permit.weight}}</td>
                        <td class="text-center">
                            <a class="icon--note" title="Notes" href="javascript:void(0)" data-bs-toggle="modal" (click)="setPermitId(permit.id)" data-bs-target="#activePermitNotesModal"></a>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="!vehicle || !vehicle?.vehiclePermits || vehicle?.vehiclePermits?.length == 0">
                    <tr>
                        <td colspan="10">No Information Available</td>
                    </tr>
                </tbody>
            </table>
            <h2 id="Decal">Decal</h2>
            <table class="mvd_table--primeng">
                <thead>
                    <tr>
                        <th>Decal Number</th>
                        <th>Decal Expiration Date</th>
                    </tr>
                </thead>
                <tbody *ngIf="decals && decals.length > 0">
                    <tr *ngFor="let d of decals">
                        <td>{{d.decalNumber}}</td>
                        <td>{{d.expirationDate | shortDate}}</td>
                    </tr>
                </tbody>
                <tbody *ngIf="!decals || decals?.length == 0">
                    <tr>
                        <td colspan="2">No Information Available</td>
                    </tr>
                </tbody>
            </table>
            <h2 id="SoldNotice">Sold Notice <button class="icon--add btn--default" type="button" (click)="issueSoldNotice()" *ngIf="vehicleOwnershipModel && !isUserAssociatedToVehicle">Add Sold Notice</button></h2>
            <table class="mvd_table--primeng">
                <thead>
                    <tr>
                        <th>Receive Date</th>
                        <th>Sold Date</th>
                        <th>Buyers Name</th>
                        <th>Buyers Address</th>
                        <th class="w--icon">Delete</th>
                    </tr>
                </thead>
                <tbody *ngIf="vehicleOwnershipModel && vehicleOwnershipModel.vehicleOwnershipSoldNotice">
                    <tr>
                        <td>{{vehicleOwnershipModel.vehicleOwnershipSoldNotice.soldNoticeReceivedDate | shortDate}}</td>
                        <td>{{vehicleOwnershipModel.vehicleOwnershipSoldNotice.dateOfSale | shortDate}}</td>
                        <td>{{vehicleOwnershipModel.vehicleOwnershipSoldNotice.buyersName}}</td>
                        <td>{{vehicleOwnershipModel.vehicleOwnershipSoldNotice.addressLine1}}</td>
                        <td class="text-center"><a class="icon--delete" title="Delete" href="javascript:void(0)" data-bs-toggle="tooltip" (click)="removeSoldNotice()"></a></td>
                    </tr>
                </tbody>
                <tbody *ngIf="!vehicleOwnershipModel || !vehicleOwnershipModel?.vehicleOwnershipSoldNotice">
                    <tr>
                        <td colspan="5">No Information Available</td>
                    </tr>
                </tbody>
            </table>
            <h2 id="Insurance">
                Insurance
                <button *ngIf="!isUserAssociatedToVehicle" class="icon--edit btn--default" type="button" (click)="editInsurance();">Edit Insurance</button>
                <button class="icon--pointer-mark btn--default" type="button" (click)="getInsurance();">Confirm Insurance</button>
            </h2>
            <table class="mvd_table--primeng">
                <thead>
                    <tr>
                        <th>Company Name</th>
                        <th>Policy Number</th>
                        <th>Policy Type</th>
                        <th>Policy Holder</th>
                        <th>Source</th>
                        <th>Notify Date</th>
                        <th>Effective Date</th>
                        <th>End Date</th>
                    </tr>
                </thead>
                <tbody *ngIf="insuranceSearchResults && insuranceSearchResults.length > 0">
                    <tr *ngFor="let insurance of insuranceSearchResults">
                        <td>{{insurance.insuranceCompanyName}}</td>
                        <td>{{insurance.insurancePolicyNumber}}</td>
                        <td>{{insurance.insurancePolicyTypeId | displayValue:insurancePolicyTypes}}</td>
                        <td>{{insurance?.customer?.customerName}}</td>
                        <td>{{insurance.insurancePolicySourceTypeId | displayValue:insurancePolicySourceTypes}}</td>
                        <td>{{insurance.notifyDate | shortDate }}</td>
                        <td>{{insurance.effectiveDate | shortDate}}</td>
                        <td>{{insurance.endDate | shortDate}}</td>
                    </tr>
                </tbody>
                <tbody *ngIf="(!insuranceSearchResults || insuranceSearchResults?.length == 0)">
                    <tr>
                        <td colspan="8">No Information Available</td>
                    </tr>
                </tbody>
            </table>
            <h2 id="DeInsurance">De-Insurance <button class="icon--add btn--default" type="button" (click)="addDeInsurance()" *ngIf="vehicleOwnershipModel">Add De-Insurance</button></h2>
            <table class="mvd_table--primeng">
                <thead>
                    <tr>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Certificate Received Date</th>
                        <th>Reason</th>
                        <th>Edit</th>
                    </tr>
                </thead>
                <tbody *ngIf="vehicleOwnershipModel && vehicleOwnershipModel?.vehicleOwnershipDeInsurances?.length">
                    <tr *ngFor="let vehicleOwnershipDeInsurance of vehicleOwnershipModel.vehicleOwnershipDeInsurances;">
                        <td>{{vehicleOwnershipDeInsurance.effectiveDate | shortDate}}</td>
                        <td>{{vehicleOwnershipDeInsurance.endDate | shortDate}}</td>
                        <td>{{vehicleOwnershipDeInsurance.receivedDate | shortDate}}</td>
                        <td>{{vehicleOwnershipDeInsurance.vehicleOwnershipDeInsuranceReasonTypeId | displayValue:vehicleOwnershipDeInsuranceReasonTypes}}</td>
                        <td class="text-center">
                            <a class="icon--edit" href="javascript:void(0)" title="Edit DeInsurance" (click)="editVehicleDeInsurance(vehicleOwnershipDeInsurance.id)"></a>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="!vehicleOwnershipModel || !vehicleOwnershipModel?.vehicleOwnershipDeInsurances?.length">
                    <tr>
                        <td colspan="5">No Information Available</td>
                    </tr>
                </tbody>
            </table>
            <h2 id="WatchYourCar">
                Watch Your Car  <button class="icon--remove btn--default" type="button" (click)="deleteWatchYourCar()" *ngIf="vehicleWatchContactModel">Remove</button>
                <button class="icon--add btn--default" type="button" (click)="showVehicleWatchContactModal()" *ngIf="vehicleOwnershipModel && !vehicleWatchContactModel && !isUserAssociatedToVehicle">Enroll</button>
            </h2>
            <table class="mvd_table--primeng">
                <thead>
                    <tr>
                        <th>Phone Number 1</th>
                        <th>Phone Number 2</th>
                        <th>Edit</th>
                    </tr>
                </thead>
                <tbody *ngIf="vehicleWatchContactModel">
                    <tr>
                        <td>{{vehicleWatchContactModel.phone1}}</td>
                        <td>{{vehicleWatchContactModel.phone2}}</td>
                        <td class="text-center">
                            <a *ngIf="!vehicleWatchContactModel.isRedacted" class="icon--edit" href="javascript:void(0)" title="Edit" (click)="editVehicleWatchContactModal()"></a>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="!vehicleWatchContactModel">
                    <tr>
                        <td colspan="3">No Information Available</td>
                    </tr>
                </tbody>
            </table>
            <h2 id="Fleets">Fleets</h2>
            <table class="mvd_table--primeng">
                <thead>
                    <tr>
                        <th>Fleet Type</th>
                        <th>Fleet Owner</th>
                        <th>Expiration</th>
                        <th>Owner Equipment Number</th>
                    </tr>
                </thead>
                <tbody *ngIf="fleet">
                    <tr>
                        <td>{{fleet.fleetTypeId | displayValue:fleetTypes}}</td>
                        <td>{{fleet.fleetCustomerName?.displayName}}</td>
                        <td>{{fleet.expirationDate | shortDate}}</td>
                        <td><ng-container *ngIf="registration">{{registration.ownerEquipmentNumber}}</ng-container></td>
                    </tr>
                </tbody>
                <tbody *ngIf="!fleet">
                    <tr>
                        <td colspan="4">No Information Available</td>
                    </tr>
                </tbody>
            </table>
            <!--Commercial Permits-->
            <h2 id="CmlPermits">Commercial Permits <button class="icon--history btn--default" type="button" (click)="viewCommercialVehiclePermitHistory()">View History</button></h2>
            <p-table #dtCVP [value]="commercialVehiclePermitNumberViewModels" [responsive]="true" class="mvd_table--primeng">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Type</th>
                        <th class="w--short">Permit #</th>
                        <th class="w--date-short">Issue Date</th>
                        <th>Expiration Date</th>
                        <th class="w--status">Status</th>
                        <th>Issued By</th>
                        <th>Issued To</th>
                        <th>USDOT #</th>
                        <th class="w--icon">Copy</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="9">
                            No Permits Found
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-cvpNumberViewModel>
                    <tr>
                        <td>{{ cvpNumberViewModel.commercialVehiclePermitTypeDisplayValue }}</td>
                        <td>
                            <a title="View Permit" href="javascript:void(0)" (click)="openCommercialVehiclePermitModal(cvpNumberViewModel.id)">{{ cvpNumberViewModel.id }}</a>
                        </td>
                        <td>{{ cvpNumberViewModel.issueDate | shortDate }}</td>
                        <td>{{ cvpNumberViewModel.expirationDate | shortDate }}</td>
                        <td>{{ cvpNumberViewModel.commercialVehiclePermitStatusTypeDisplayValue }}</td>
                        <td class="td--hover-show">{{ cvpNumberViewModel.createdBy }}</td>
                        <td class="td--hover-show">{{ cvpNumberViewModel.customerDisplayName }}</td>
                        <td>{{ cvpNumberViewModel.customerUSDOTNumber }}</td>
                        <td class="text-center">
                            <a class="icon--copy" (click)="copyCommercialPermit(cvpNumberViewModel.id)"></a>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
            <h2 id="cmlOOSRegistration">Out Of Jurisdiction Registrations<button *ngIf="!isUserAssociatedToVehicle" class="icon--add btn--default" type="button" (click)="addOutOfStateRegistration()">Add Registration</button><button class="icon--add btn--default" type="button" (click)="viewOutOfStateRegistrationHistory()">View History</button></h2>
            <p-table #dtCVPOOSR [value]="activeOutOfJurisdictionRegistration" styleClass="p-datatable-striped">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Plate Number</th>
                        <th>Plate State</th>
                        <th>Expiration Date</th>
                        <th>Updated Date</th>
                        <th>Update By</th>
                        <th class="w--edit">Edit</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="6">
                            No Permits Found
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-activeOutOfJurisdictionRegistration>
                    <tr>
                        <td>{{ activeOutOfJurisdictionRegistration.plateNumber }}</td>
                        <td>{{ activeOutOfJurisdictionRegistration.jurisdictionId | jurisdictionCode }}</td>
                        <td>{{ activeOutOfJurisdictionRegistration.expirationDate | shortDate }}</td>
                        <td>{{ activeOutOfJurisdictionRegistration.updatedDate | shortDate }}</td>
                        <td>{{ activeOutOfJurisdictionRegistration.updatedBy }}</td>
                        <td class="text-center">
                            <a class="icon--edit" (click)="editOutOfStateRegistration()"></a>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <!--Notes Modal -->
        <div class="modal fade" id="activePermitNotesModal" tabindex="-1" role="dialog" aria-labelledby="labelNotes" *ngIf="permitSelected">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        <h4 class="modal-title" id="labelNotes">Notes</h4>
                    </div>
                    <div class="modal__note">
                        <note [(notes)]="activePermitNotes" [noteIdentificationValue]="permitId" [noteIdentificationTypeId]="7" [countDisplayClass]="'note-count'" [isWip]="false" [isReadonly]="true"></note>
                    </div>
                    <div class="modal-footer">
                        <div class="btn--group">
                            <button class="btn--primary" type="button" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
<div class="list--ancors__spacer"></div>